import Vue from 'vue'
import moment from 'moment'
import _ from 'lodash'

Vue.filter('period', function(value) {
  if(!value) {
    return;
  }

  return moment(value).fromNow(true)
})

Vue.filter('optional', function(value) {
  return value || '-'
})

Vue.filter('datetime', function(value) {
  if(!value) {
    return '-'
  }

  return moment(value).format('DD-MM-YYYY HH:mm:ss')
})
Vue.filter('sensorMeasurement', function(measurement) {
  if(!measurement) return '-'

  switch (measurement.type){
    case'EC':
      return (Math.round(measurement.value * 100) / 100).toFixed(2) + 'mS/cm'
    case'WC':
      return (Math.round(measurement.value * 10) / 10).toFixed(1) + '%'
    case'RH':
      return (Math.round(measurement.value * 100) / 100).toFixed(2) + '%'
    case'CO2':
      return (Math.round(measurement.value * 10) / 10).toFixed(1) + 'ppm'
    case'ROOT_TEMP':
    case'TEMP':
      return (Math.round(measurement.value * 10) / 10).toFixed(1) + '°C'
  }
  return measurement.value
})

Vue.filter('enum', function(value) {
  return _.startCase(value.toLowerCase())
})
